import { render } from "./AdminServerInfoPage.vue?vue&type=template&id=290e0acc&scoped=true"
import script from "./AdminServerInfoPage.vue?vue&type=script&lang=js"
export * from "./AdminServerInfoPage.vue?vue&type=script&lang=js"

import "./AdminServerInfoPage.vue?vue&type=style&index=0&id=290e0acc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290e0acc"]])

export default __exports__